<template>
  <div>
    <!-- @click="handleSubmit" @click="success"  -->
    <button  id="sendCodePrivacy" type="button" class="btn btn-default" :class="{'is-default': type==='btn', 'is-text': type==='text', 'is-text-mini': type==='text-mini',
    'is-info': type==='info'}">
      <img class="icon" :src="iconUrl" />
    </button>
    <common-modal
        :isShow="isVerificationCodeLayer"
        :disableClose="true"
        :modalWidth="400">
      <div>
        <h3 class="title">安全验证</h3>
        <!-- <div class="verification-code" id="captcha"></div> -->
        <div class="verification-code" id="captcha-element"></div>
      </div>
    </common-modal>
  </div>
</template>

<script>
const CommonModal = () => import("@/components/Common/CommonModal");
import api from '@/api'

export default {
  name: "PrivacyButton",
  props: {
    type: {
      type: String,
      default: 'btn'
    }
  },
  data() {
    return {
      captcha:null,
      token: "",
      isShow: false,
      iconUrl: require("@/assets/icon-visible.png"),
      icon: [{
        url: require("@/assets/icon-invisible.png")
      },{
        url: require("@/assets/icon-visible.png")
      }],
      isAllowNvc: true,
      isVerificationCodeLayer: false
    }
  },
  components: {
    CommonModal
  },
  watch: {
    isShow(val) {
      this.iconUrl = val ? this.icon[0].url : this.icon[1].url;
    }
  },
  created() {
    this.token = this.$store.state.user.userToken;
    this.getPrivacyProtectionStatus();
  },
  mounted() {
    this.initAWSC();
  },
  methods: {
    async handleSubmit () {
      if (!this.isAllowNvc) {
        return;
      }

      // 人机验证
      if (!window.nvc) return;
      this.$loading.show();
      window.nvc.getNVCValAsync(async (nvcVal) => {
        // 无痕验证获取nvc data，用无痕验证模式调是否用开启隐私保护接口
        const request = this.getRequest("AliYunAfsNvc", nvcVal);
        await this.updatePrivacyStatus(request);
      });
    },
    async getPrivacyProtectionStatus () {
      const { success, data, errMsg } = await api.user.changePrivacyProtectionIsOpen(this.token)
      if(success) {
        this.isShow = data;
        this.$store.commit("SET_IS_MASK_VALUE", data);
      } else {
        this.$alert.show(errMsg)
      }
    },
    getInstance(instance) {
      this.captcha = instance
    },
    fail(error) {
      console.error(error);
      this.isAllowNvc = false
    },
    async success(captchaVerifyParam) {
      console.log(captchaVerifyParam,'captchaVerifyParam');
      this.isVerificationCodeLayer = false;
      this.isAllowNvc = true
      this.$loading.show();
      const request = this.getRequest("AliYunAfsNc", captchaVerifyParam);
      await this.updatePrivacyStatus(request);
    },
    initAWSC () {
      console.log("初始化");
      if (!window.initAliyunCaptcha) return
      // window.AWSC.use("nvc", (state, module) => {
      //   // 初始化 调用module.init进行初始化
      //   window.nvc = module.init({
      //     appkey: "FFFF0N00000000009D85",
      //     scene: "nvc_message",
      //     renderTo:'#captcha',
      //     // test: module.TEST_NC_PASS,
      //     // 二次验证获取人机信息串，跟随业务请求一起上传至业务服务器，由业务服务器进行验签。
      //     success: async (data) => {
      //       this.isVerificationCodeLayer = false;
      //       this.$loading.show();
      //       const request = this.getRequest("AliYunAfsNc", data);
      //       await this.updatePrivacyStatus(request);
      //     },
      //     // 前端二次验证失败时触发该回调参数
      //     fail: (failCode) => {
      //       window.console && console.log(failCode);
      //       this.isAllowNvc = false;
      //     },
      //     // 前端二次验证加载异常时触发该回调参数。
      //     error: (errorCode) => {
      //       window.console && console.log(errorCode);
      //       this.isAllowNvc = false;
      //     }
      //   });
      // });
      window.initAliyunCaptcha({
    // 场景ID。根据步骤二新建验证场景后，您可以在验证码场景列表，获取该场景的场景ID
      SceneId: "tqbrb5ax",
      // 验证码模式，popup表示弹出式，embed表示嵌入式。无需修改
      mode: "popup",
      // 页面上预留的渲染验证码的元素，与原代码中预留的页面元素保持一致。
      element: "#captcha-element",
      // 触发验证码弹窗或无痕验证的元素
      button: "#sendCodePrivacy",
      // 验证码验证通过回调函数
      success: this.success,
      // 验证码验证不通过回调函数
      fail: this.fail,
      // 绑定验证码实例回调函数，该回调会在验证码初始化成功后调用
      getInstance: this.getInstance,
      // 滑块验证和一点即过的验证形态触发框体样式，支持自定义宽度和高度，单位为px。兼容历史参数名。
      slideStyle: {
        width: 360,
        height: 40,
      },
      // ...其他参数，参考initAliyunCaptcha参数说明
    });
    },
    async updatePrivacyStatus(request) {
      if (!this.isAllowNvc) return;
      const { success, errMsg } = await api.user.updateUserPrivacyProtection(request);
      this.$loading.hide();
      if (!success) {
        this.$alert.show(errMsg);
        // 初始化
        this.initAWSC()
      } else {
        this.isShow = request.isOpenPrivacyProtection;
        this.$store.commit("SET_IS_MASK_VALUE", this.isShow);
        this.$emit("privacy-switch", true);
        // 初始化
        this.initAWSC()
        
      }
    },
    // 无痕验证模式发送短信失败处理方法
    afsFailureHandler(code) {
      this.isVerificationCodeLayer = true;
      // 行为可疑，进入二次滑动验证
      if (code === 'NvcNc') {
        const ncoption = {
          renderTo: "#captcha",
        }
        let childNodes = document.getElementById('captcha').childNodes;
        for (let i = 0; i < childNodes.length; i++) {
          let childNode = childNodes[i];
          childNode.parentElement.removeChild(childNode);
        }
        // 唤醒二次验证（滑动验证码）
        window.nvc.getNC(ncoption);
      } else if (code === 'Block') {
        // 返回block，禁止提交
        this.isAllowNvc = false
        this.$alert.show(
            "网络错误，请刷新页面重试。"
        );
      }
    },
    getRequest (codeType, codeValue) {
      return {
        userName: this.token,
        isOpenPrivacyProtection: !this.isShow,
        codeType: codeType,
        codeValue: codeValue,
        sceneId: 'tqbrb5ax',
				captchaVerifyParam: codeValue,
      };
    }
  }
}
</script>

<style scoped lang="less">
.btn {
  height: 36px;
  width: 36px;
  border: none;
  border-radius: 0;
  //padding: 0 12px 0 12px;
  position: relative;
  &:focus {
    outline: none;
  }
  &.btn-default {
    background-color: #FFFFFF;
    border: 1px solid #cccccc;
    & .icon {
      height: 22px;
      width: 22px;
    }
    &.is-default {
      & .icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    &.is-text-mini {
      height: 22px;
      & .icon {
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%);
      }
    }
    &.is-text {
      height: auto;
      padding: 0 0 0 27px;
      background-color: transparent;
      border: none;
      & .icon {
        position: absolute;
        top: 50%;
        transform: translateY(-50%);
        left: 0;
      }
    }
    &.is-info {
      height: 25px;
      background-color: #FFFFFF;
      border: 1px solid #cccccc;
      & .icon {
        height: 20px;
        width: 20px;
      }
    }
  }
}
#captcha {
  position: relative;
  width: 300px;
  margin: 15px auto;
  .nc_wrapper {
    width: 100%;
  }
}
.title {
  margin: 10px auto 0;
  text-align: center;
}
</style>